module.exports = __webpack_public_path__ + "media/images/athletes/604-3339682ecba79c555df7a338eaaed246.png";